import Service from '@ember/service'

export default class DemoEventTrackerService extends Service implements EventTracker {
  track(): void {}
  trackOnce(): void {}
}
